import { flagFactory } from '../icon';
import Svg from './fi.svg';

export default flagFactory(Svg);
